import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { ImageUploadComponent } from '../core/component/image-upload/image-upload.component';
import { ImageLoadDirective } from '../helper/directive/image-load.directive';
import { FilterPipe } from '../helper/pipe/filter.pipe';
import { ImageDocGridComponent } from './component/image-doc-grid/image-doc-grid.component';
import { GoBackDirective } from './directive/go-back.directive';
import { LazyLoadRowDirective } from './directive/lazy-load-row.directive';
import { NoDoubleClickDirective } from './directive/no-double-click.directive';
import { DateFormatPipe } from './pipe/date-format.pipe';
import { SortPipe } from './pipe/sort.pipe';
import { ClickOutsideDirective } from './directive/click-outside.directive';
import { FileUploadModule } from 'primeng/fileupload';

@NgModule({
  declarations: [
    ImageUploadComponent,
    ImageLoadDirective,
    ImageDocGridComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FileUploadModule
  ],
  exports: [ImageUploadComponent, ImageLoadDirective, ImageDocGridComponent,]
})
export class ImageUploadModule { }



@NgModule({
  declarations: [
    FilterPipe,
    NoDoubleClickDirective,
    DateFormatPipe,
    GoBackDirective,
    LazyLoadRowDirective,
    ClickOutsideDirective,
    SortPipe
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    DropdownModule,
    TableModule,
    CalendarModule,
  ],
  exports: [DateFormatPipe, NoDoubleClickDirective, FilterPipe, GoBackDirective, LazyLoadRowDirective, SortPipe, ClickOutsideDirective, DropdownModule]
})
export class SharedModule { }
